import xhr from './xhr'
import URL from './xhr/url'

export const applyMerchant = (merchant) => xhr({
  url: URL.basic.applyMerchant,
  body: merchant,
  silentError: true,
  loadingMessage: '创建中……'
});

export const queryApplicationsByOpenId = (openId) => xhr({
  url: URL.basic.queryApplicationsByOpenId + openId,
  method: 'GET',
  silentError: true,
  loadingMessage: '查询中……'
});

export const verifyList = (vehicleNo,detectStart,detectEnd,incomplete,merchantName,pageSize,start,page) => xhr({
  method:'get',
  url: URL.basic.verifyList,
  body: {
    vehicleNo,detectStart,detectEnd,incomplete,merchantName,pageSize,start,page
  },
  silentError: true,
  loadingMessage: '操作中……'
});
export const login = (username, password) => xhr({
  url: URL.basic.login,
  body: {
    username,
    password
  },
  silentError: true,
  loadingMessage: '登录中……'
});
export const doVerify = (id,result) => xhr({
  url: URL.basic.doVerify,
  body: {
    id,
    result
  },
  silentError: true,
});

export const accountOverview = (dsId, year, quarter) => xhr({
  url: URL.basic.accountOverview,
  method: 'POST',
  body: {
    dsId,
    year,
    quarter
  },
  silentError: true,
  loadingMessage: '查询中……'
});

export const listStatements = (page, pageSize, year, quarter, merchantName, billNo, status) => xhr ({
  url: URL.basic.listStatements,
  method: 'POST',
  header: {
    pageNum : page,
    pageSize
  },
  body: {
    year,
    quarter,
    merchantName,
    billNo,
    status
  },
  silentError: true,
  loadingMessage: '查询中……'
});

export const createStatements = (year, quarter) => xhr ({
  url: URL.basic.createStatements,
  method: 'POST',
  body: {
    year,
    quarter
  },
  silentError: true,
  loadingMessage: '创建中……'
});

export const listTransactions = (page, pageSize, dsId, from, to, type, operator) => xhr ({
  url: URL.basic.listTransactions,
  method: 'POST',
  header: {
    pageNum: page,
    pageSize
  },
  body: {
    dsId,
    from,
    to,
    type,
    operator
  },
  silentError: true,
  loadingMessage: '查询中……'
});

export const sendBill = (billId) => xhr ({
  url: URL.basic.sendBill,
  method: 'POST',
  body: {
    billId
  },
  silentError: true,
  loadingMessage: '发送中……'
});

export const confirmBill = (billId, status, remark) => xhr ({
  url: URL.basic.confirmBill,
  method: 'POST',
  body: {
    billId,
    status,
    remark
  },
  silentError: true,
  loadingMessage: '提交中……'
});

export const listRechargeRecords = (page, pageSize, from, to, status, merchantName, channel, lsh) => xhr ({
  url: URL.basic.listRechargeRecords,
  methods: 'POST',
  header: {
    pageNum: page,
    pageSize
  },
  body: {
    merchantName,
    from,
    to,
    status,
    channel,
    lsh
  },
  silentError: true,
  loadingMessage: '查询中……'
});

export const createRecharge = (amount, channel) => xhr ({
  url: URL.basic.createRecharge,
  method: 'POST',
  body: {
    amount,
    channel
  },
  silentError: true,
  loadingMessage: '提交中……'
});

export const cancelRecharge = (id, cancelReason) => xhr ({
  url: URL.basic.cancelRecharge,
  method: 'POST',
  body: {
    id,
    cancelReason
  },
  silentError: true,
  loadingMessage: '取消中……'
});

export const confirmRecharge = (id, lsh) => xhr ({
  url: URL.basic.confirmRecharge,
  method: 'POST',
  body: {
    id,
    lsh
  },
  silentError: true,
  loadingMessage: '确认中……'
});

export const fetchForAudit = () => xhr({
  url: URL.basic.fetchForAudit,
  method: 'GET',
  body: {},
  silentError: true,
  loadingMessage: '加载中……'
});

export const openSearch = (plateColor, vehicleNo) => xhr({
  url: URL.basic.openSearch,
  method: 'POST',
  body: {
    plateColor,
    vehicleNo
  },
  silentError: true,
  loadingMessage: '查询中……'
});